import { useQuery } from '@tanstack/react-query';
import {
  getInvoices, type InvoiceFilters 
} from '../api';

export function useInvoices(filters?: InvoiceFilters) {
  return useQuery({
    queryKey: ['invoices', filters],
    queryFn: () => getInvoices(filters),
  });
}
